/*
  Mobile-only swipeable product card images for the collection grid.

  Works with Dawn's existing card markup - it does not rebuild the card.
  For each .card__media .media that holds two or more <img>, it:
    - adds the .card-swipe class (CSS turns it into a scroll-snap carousel)
    - appends a thin indicator bar and moves it as the user scrolls
    - restores tap-to-open-product, since the scroller sits above Dawn's
      full-card link overlay

  Desktop (>= 750px) is left completely alone.
*/
(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 749px)';
  var mediaQuery = window.matchMedia(MOBILE_QUERY);
  var SELECTOR = '.card-wrapper .card__media .media';
  var TAP_SLOP = 8; // px of movement still counted as a tap
  var TAP_TIME = 500; // ms

  function buildIndicator(media, slideCount) {
    var host = media.closest('.card__media') || media.parentElement;
    if (!host || host.querySelector('.card-swipe-indicator')) return null;

    var indicator = document.createElement('div');
    indicator.className = 'card-swipe-indicator';
    indicator.setAttribute('aria-hidden', 'true');

    var bar = document.createElement('span');
    bar.className = 'card-swipe-indicator__bar';
    bar.style.width = 100 / slideCount + '%';

    indicator.appendChild(bar);
    host.appendChild(indicator);
    return bar;
  }

  function restoreTapToOpen(media) {
    var wrapper = media.closest('.card-wrapper');
    if (!wrapper) return;

    var link = wrapper.querySelector('.card__heading a[href], a.card__link[href], a[href]');
    if (!link) return;

    var startX = 0;
    var startY = 0;
    var startTime = 0;
    var moved = false;

    media.addEventListener(
      'pointerdown',
      function (event) {
        startX = event.clientX;
        startY = event.clientY;
        startTime = Date.now();
        moved = false;
      },
      { passive: true }
    );

    media.addEventListener(
      'pointermove',
      function (event) {
        if (
          Math.abs(event.clientX - startX) > TAP_SLOP ||
          Math.abs(event.clientY - startY) > TAP_SLOP
        ) {
          moved = true;
        }
      },
      { passive: true }
    );

    media.addEventListener(
      'pointerup',
      function () {
        if (moved) return;
        if (Date.now() - startTime > TAP_TIME) return;
        link.click();
      },
      { passive: true }
    );
  }

  function init(media) {
    if (media.dataset.cardSwipeReady === 'true') return;

    var slides = media.querySelectorAll('img');
    if (slides.length < 2) return;

    media.dataset.cardSwipeReady = 'true';
    media.classList.add('card-swipe');

    var bar = buildIndicator(media, slides.length);
    if (bar) {
      var travel = (slides.length - 1) * 100;
      var ticking = false;

      var update = function () {
        var max = media.scrollWidth - media.clientWidth;
        var progress = max > 0 ? media.scrollLeft / max : 0;
        bar.style.transform = 'translateX(' + progress * travel + '%)';
        ticking = false;
      };

      media.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(update);
        },
        { passive: true }
      );

      update();
    }

    restoreTapToOpen(media);
  }

  function run() {
    if (!mediaQuery.matches) return;
    document.querySelectorAll(SELECTOR).forEach(init);
  }

  function watchForNewCards() {
    var observer = new MutationObserver(function () {
      window.requestAnimationFrame(run);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);

  if (typeof mediaQuery.addEventListener === 'function') {
    mediaQuery.addEventListener('change', run);
  } else if (typeof mediaQuery.addListener === 'function') {
    mediaQuery.addListener(run);
  }

  watchForNewCards();
})();
